import { StyleSheet } from 'aphrodite';

// tslint:disable:object-literal-key-quotes

export const styleSheet = StyleSheet.create({
	badge: {
		alignItems: 'center',
		background: '#d22628',
		borderRadius: '50%',
		boxShadow: '0 1px 0 rgba(0,0,0,.27)',
		color: '#fff',
		display: 'flex',
		fontSize: 12,
		fontWeight: 500,
		height: 22,
		justifyContent: 'center',
		lineHeight: '22px',
		opacity: 0,
		position: 'absolute',
		right: -4,
		textAlign: 'center',
		top: -4,
		transform: 'scale(0, 0)',
		width: 22,
	},
	badgeActive: {
		opacity: 1,
		transform: 'scale(1, 1)',
		transition: 'transform 250ms ease, opacity 250ms ease',
	},
	closeIcon: {
		':nth-child(1n) > path': {
			transform: 'rotate(-30deg)',
		},
	},
	container: {
		alignItems: 'center',
		background: '#96c42b',
		borderRadius: '50%',
		bottom: 20,
		boxShadow: '0 1px 6px 0 rgba(0,0,0,.06), 0 2px 32px 0 rgba(0,0,0,.16)',
		cursor: 'pointer',
		display: 'flex',
		height: 60,
		justifyContent: 'center',
		opacity: 0,
		position: 'fixed',
		right: 35,
		transform: 'scale(0.1, 0.1)',
		transformOrigin: 'center',
		width: 60,
		zIndex: 9999,
		// tslint:disable-next-line:object-literal-sort-keys
		':focus': {
			outline: 'none',
		},
	},
	containerActive: {
		opacity: 1,
		transform: 'scale(1, 1)',
		transition: 'transform 250ms ease, opacity 250ms ease',
	},
	containerContent: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		position: 'relative',
		width: '100%',
	},
	icon: {
		alignSelf: 'center',
		fill: '#fff',
		justifySelf: 'center',
		left: '50%',
		position: 'absolute',
		top: '50%',
		transform: 'translate(-50%, -50%)',
		// tslint:disable-next-line:object-literal-sort-keys
		':nth-child(1n) > path': {
			opacity: 0,
			transform: 'scale(0.1, 0.1)',
			transformOrigin: 'center',
			transition: 'transform .16s linear, opacity .08s linear',
		},
	},
	iconActive: {
		':nth-child(1n) > path': {
			opacity: 1,
			transform: 'scale(1, 1)',
		},
	},
	openIcon: {
	},
});
